import { render } from "./SponsorDtlForm.vue?vue&type=template&id=10111b44"
import script from "./SponsorDtlForm.vue?vue&type=script&lang=js"
export * from "./SponsorDtlForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__